// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"720":"faq","737":"delete-account","875":"terms-and-conditions","999":"survey"}[chunkId] + "." + {"720":"c8b6982c","737":"4316faee","875":"045a2ca0","999":"a7af6b1c"}[chunkId] + ".js";
};